const $ = window.jQuery

/**
 * Enables 'Leaflet' plugin specific scripting
 */
const Leaflet = {

    /**
     * Initialise functionality
     */
    init() {

        this.initInstances()

    },

    /**
     * Initialise maps with their configs stored in data attributes
     */
    initInstances() {

        const vm = this

        $('[data-leaflet-markers]').each(function () {

            const $container        = $(this)
            const markers           = $container.data('leaflet-markers')            || []
            const mapConfig         = $container.data('leaflet-map-config')         || {}
            const tileUrl           = $container.data('leaflet-tile-url')           || ''
            const tileConfig        = $container.data('leaflet-tile-config')        || {}
            const markerIconConfig  = $container.data('leaflet-marker-icon-config') || {}

            vm.setupMap($container, markers, mapConfig, tileUrl, tileConfig, markerIconConfig)

        })

    },

    /**
     * Setup map and add its markers
     * @param {jQuery element} $container jQuery element to initialise map onto
     * @param {array} markers List of markers with their icon, icon colour, and coordinates
     * @param {object} mapConfig Override default config for Leaflet map
     * @param {string} tileUrl Override default Leaflet tile layer url template
     * @param {object} tileConfig Override default config for Leaflet tile layer
     * @param {object} markerIconConfig Override default config for Leaflet marker icons
     */
    setupMap($container, markers = [], mapConfig = {}, tileUrl = '', tileConfig = {}, markerIconConfig = {}) {

        const container = $container[0]

        // initialise map
        let map = L.map(container, {
            ...{
                center:             [0, 0],
                zoom:               14,
                zoomControl:        false,
                scrollWheelZoom:    true,
                maxBounds:          [[-90, -180], [90, 180]] // limit to whole world
            },
            ...mapConfig
        })

        // add tiles to map
        L.tileLayer(tileUrl || 'https://stamen-tiles-{s}.a.ssl.fastly.net/toner-lite/{z}/{x}/{y}{r}.{ext}', {
            ...{
                attribution:        'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                minZoom:            1.5,
                maxZoom:            20,
                ext:                'png',
                noWrap:             true,
            },
            ...tileConfig
        }).addTo(map)

        // add markers to map
        markers.forEach(marker => {

            const { lat, long } = marker.coordinates

            L.marker(
                [lat, long], {
                icon: L.icon({
                    ...{
                        iconUrl:        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAACtElEQVRogeWazYuNURzHPzNoyCWJxmSKRAnlWelaWthosLOh/ANWLCw1kyZbbrqGBVsbJVlIibxLpCzIQiQ1eRu5V/cyXhbnPN1x5758z3PPOU/41K+m7u/5nu93nuc559znufCP0OdZbxEwAmwDEmA1sMR+NgW8BJ4A14DLwBfP4/fMEFAGqsAvsarAGWBtDn5nMQCMARX0AM31DThmtXJhGXCjg0HXugOsiJoA2AS87tF4q3pltaMwGCjEzDCDoUPMx1wCoUKkdZvA98xYhBBpjYcKMURvs5Nr1YE1IYKUI4ZIa8J3iAJmFY4dpGLH7kq/GGSnKmipAyeAoj2uYP8u2c9UFgI7HPq7chr9v/gG2NxBK7E9qt4pn0EeiIPWuoRISWyvonnPYw7eiYMed9AsiZqTXhJY6uKgWxw0i6JmzUsCi3oZuEwIBVHzqyKmzlpTDgZVvI6tin0S+zaIfS69H5UmNcgLsW+f2AewV+x77qDZlXH0GzMR9BL0CWTUYw72iIOmC2KnMK4L4i6fQZYDPxwGr2PWiZlblK00tiiqzndgsc8gAI8dDPiqm6o59WYHuOTQ64uLIUTXE/ds/ARWhQgC8ChikOsuxlwuLTBPBmNRDilewGwZQp+Nt8A8F2OuZ6QCnHU8JgsnMVNvUIbRd8NZ6jONJ/gyrmcEzKp8LsNxKiXC7LZbspIwz7g+AEtjhUgZ9WC8uQ5ETWBZgN+H2c9wnKl8sl8wqNZIZO9/0A88bGHKta7GNt6KBPP6LGuIKrAuuus2qN8gW9XBHPy2ZQB4inuI+8CcHPx2pAhMo4eoARtzcSpwFD3IoZw8SswFbtE9xBWybY+iMgy8p32IScxrvL+C3Zivqs0hpoHtOfrKxBFmBzmcq6OM9AHnaYS4gP9fI0WjgHnjdBe3Vw7/L78ByP0EVSkVHdcAAAAASUVORK5CYII=',
                        iconSize:       [45, 45],
                        iconAnchor:     [22.5, 45],
                    },
                    ...markerIconConfig
                }),
            }).addTo(map)

        })

        // fit map viewport to show all markers
        const coordinates   = markers.map(m => [m.coordinates.lat, m.coordinates.long])
        const bounds        = L.latLngBounds(coordinates).pad(0.1)
        map.fitBounds(bounds, { maxZoom: 14 })

    },

}

export default Leaflet;